import { APP_INITIALIZER, ModuleWithProviders, NgModule } from '@angular/core';
import { SessionConfig } from './session.types';
import { SESSION_CONFIG } from './session.tokens';
import { SessionService } from './session.service';

const SESSION_DEFAULTS: SessionConfig = {
  idleTimeoutMs: 15 * 60_000,
  warningBeforeMs: 60_000,
  checkIntervalMs: 1_000,
  activityThrottleMs: 1_000,
  persistStrategy: 'localStorage',
  storageKeyLastActivity: '__app.lastActivity',
  storageKeySessionId: '__app.sessionId',
  broadcastChannelName: 'app-session',
  crossTab: 'global',
  endSessionOn401: true,
  performRedirectOnLogout: true,
  postLogoutRedirectUri: '/' 
};

export function sessionInitFactory(session: SessionService): () => void {
  return () => session.init();
}

@NgModule()
export class SessionModule {
  static forRoot(config?: Partial<SessionConfig>): ModuleWithProviders<SessionModule> {
    const resolved: SessionConfig = { ...SESSION_DEFAULTS, ...(config ?? {}) };
    return {
      ngModule: SessionModule,
      providers: [
        { provide: SESSION_CONFIG, useValue: resolved },
        {
          provide: APP_INITIALIZER,
          multi: true,
          useFactory: sessionInitFactory,
          deps: [SessionService]
        }
      ]
    };
  }
}
